import { createSelector } from 'reselect'
import { selectBase } from 'selectors/bootstrap/selectBase'
import { STATES as STORE_STATES } from 'ducks/bootstrap/constants'

export const selectIsAgentsBootstrapped = createSelector(
  selectBase,
  bootstrap => bootstrap.agents === STORE_STATES.LOADED
)
